import { useState } from 'react';
import { IDespesaFullDTO } from '../../../../models/happy-code-api.model';
import { useDespesaService } from '../../../../services/despesa.service';
import { useGlobalContext } from '../../../../context/GlobalContext';

import { useHistory } from 'react-router-dom';
import { useNotificationService } from '../../../../services/notification.service';
import useValidationFormDespesa from './validation-form';

export default function useSaveAndFetchDataDespesa(idDespesa?: number) {
	const [despesa, setDespesa] = useState<IDespesaFullDTO>();
	const despesaService = useDespesaService();
	const { unidade } = useGlobalContext();
	const history = useHistory();
	const notification = useNotificationService();
	const { setIsGlobalLoading } = useGlobalContext();

	const id = idDespesa ?? undefined;

	const validateFields = useValidationFormDespesa();

	const fetchDespesaByIdForm = () => {
		despesaService.findFullCustomEdit(id).then(({ data }) => setDespesa(data));
	};

	const createParcelamento = () => {
		setIsGlobalLoading(true);
		despesaService
			.createParcelamento(despesa)
			.then(() => {
				notification({
					description: `Despesa cadastrada com sucesso!`,
					type: 'success',
					message: 'Sucesso!',
				});
				history.push('/contas-a-pagar');
			})
			.finally(() => {
				setIsGlobalLoading(false);
			});
	};

	const createRepeticao = () => {
		setIsGlobalLoading(true);
		despesaService
			.createRepeticao(despesa)
			.then(() => {
				notification({
					description: `Despesa cadastrada com sucesso!`,
					type: 'success',
					message: 'Sucesso!',
				});
				history.push('/contas-a-pagar');
			})
			.finally(() => {
				setIsGlobalLoading(false);
			});
	};

	const createOrPatchDespesa = () => {
		if (!validateFields(despesa, id)) return;
		despesa.unidade = unidade;
		if (despesa.parcelamentoDto?.qtdRepetir && despesa.recorrenciaDto?.qtdFrequencia) createRepeticao();
		else if (despesa.recorrenciaDto?.qtdRepetir) {
			createRepeticao();
		} else if (despesa.parcelamentoDto?.qtdRepetir) createParcelamento();
		else {
			setIsGlobalLoading(true);
			if (id) {
				despesaService
					.patchCustom(despesa)
					.then(() => {
						notification({
							description: `Despesa alterada com sucesso!`,
							type: 'success',
							message: 'Sucesso!',
						});
						history.push('/contas-a-pagar');
					})
					.finally(() => {
						setIsGlobalLoading(false);
					});
			} else {
				despesaService
					.createCustom(despesa)
					.then(() => {
						notification({
							description: `Despesa cadastrada com sucesso!`,
							type: 'success',
							message: 'Sucesso!',
						});
						history.push('/contas-a-pagar');
					})
					.finally(() => {
						setIsGlobalLoading(false);
					});
			}
		}
	};

	return { despesa, setDespesa, fetchDespesaByIdForm, createOrPatchDespesa };
}
